import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../services/Auth/auth.service';
import { MenuAuthService } from '../../services/common/menu-auth.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AESEncryptDecryptService } from '../../services/aesencrypt-decrypt.service';

interface MenuItem {
  menu_name: string;
  menu_icon: string;
  children: ModuleItem[];
}

interface ModuleItem {
  module_name: string;
  module_icon: string;
  is_delete_permisssion: number;
  children: {
    add?: [string, string, string];
    listing?: [string, string, string];
    lising?: [string, string, string]; // Keep typo for compatibility
  };
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  public Menu: MenuItem[] = [];
  public displayName: string = '';
  public userRole: string = 'User';
  // public isAgent: boolean = false;
  message: string = '';

  // Predefined menu structure for better organization
  public menuStructure = [
    {
      section: 'Analytics & Reports',
      icon: 'ri-bar-chart-2-line',
      menus: ['Analytics & Reports']
    },
    {
      section: 'Quotes Management',
      icon: 'ri-file-text-line',
      menus: ['Quotes Management']
    },
    {
      section: 'Policies',
      icon: 'ri-shield-check-line',
      menus: ['Policies']
    },
    {
      section: 'Claims Management',
      icon: 'ri-file-damage-line',
      menus: ['Claims Management']
    },
    {
      section: 'Customer Management',
      icon: 'ri-user-heart-line',
      menus: ['Customer Management']
    },
    {
      section: 'Products & Binders',
      icon: 'ri-box-3-line',
      menus: ['Products & Binders']
    },
    {
      section: 'Insurance Companies',
      icon: 'ri-building-line',
      menus: ['Insurance Companies']
    },
    {
      section: 'Agents Management',
      icon: 'ri-user-line',
      menus: ['Agents Management']
    },
    {
      section: 'User Management',
      icon: 'ri-user-settings-line',
      menus: ['User Management']
    },
    {
      section: 'Payments & Finance',
      icon: 'ri-money-dollar-circle-line',
      menus: ['Payments & Finance']
    },
    {
      section: 'System Settings',
      icon: 'ri-settings-3-line',
      menus: ['System Settings']
    },
    {
      section: 'Payment Gateway',
      icon: 'ri-secure-payment-line',
      menus: ['Payment Gateway']
    },
    {
      section: 'Communication',
      icon: 'ri-mail-line',
      menus: ['Communication']
    },
    {
      section: 'Export & Reports',
      icon: 'ri-file-download-line',
      menus: ['Export & Reports']
    },
    {
      section: 'Settings & Configuration',
      icon: 'ri-settings-4-line',
      menus: ['Settings & Configuration']
    }
  ];

  constructor(
    private auth: AESEncryptDecryptService,
    private _AuthService: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private menuAuth: MenuAuthService
  ) { }

  ngOnInit() {
    // this.isAgent = !!localStorage.getItem('agent##');
    this.loadMenuData();
    this.initSidebarToggle();
    
  }
  activeSubmenu: string | null = null; // Track active submenu

  toggleSubmenu(submenuId: string): void {
    this.activeSubmenu = this.activeSubmenu === submenuId ? null : submenuId;
  }
  isSidebarOpen: boolean = true; // Sidebar is open by default

  toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }
  loadMenuData() {
    const menuItem = localStorage.getItem('menuItem');
    this.Menu = menuItem ? JSON.parse(menuItem) : [];
    this.displayName = localStorage.getItem('displayName') || 'Unknown';
    this.userRole = localStorage.getItem('role') || 'User';
    
  }

  getMenusBySection(sectionName: string): MenuItem[] {

    const section = this.menuStructure.find(s => s.section === sectionName);
    if (!section) return [];

    return this.Menu.filter(menu => section.menus.includes(menu.menu_name));
  }

  

  getRoute(path: string): string {
    
    if (path.startsWith('/')) return path;
    return path.startsWith('admin') ? `/${path}` : `/admin/${path}`;
  }
  getModuleIconClass(iconName: string): string {
    const iconMap: { [key: string]: string } = {
      'fa-user-circle': 'ri-user-line',
      'fas fa-book': 'ri-book-line',
      'fa-car-side': 'ri-car-line',
      'fa-dolly': 'ri-truck-line',
      'fa-user': 'ri-user-line',
      'fa fa-group': 'ri-group-line',
      'fa-truck-monster': 'ri-truck-line',
      'fa-newspaper-o': 'ri-newspaper-line',
      'fa-list': 'ri-list-check-2-line',
      'fa-calculator': 'ri-calculator-line',
      'fa-file-word-o': 'ri-file-word-line',
      'fa-bars': 'ri-menu-line',
      'fa-align-left': 'ri-align-left',
      'fa fa-search': 'ri-search-line',
      'fa fa-money': 'ri-money-dollar-circle-line',
      'fa-file-text': 'ri-file-text-line',
      'fa-fa-user': 'ri-user-line',
      'fs-user': 'ri-user-line',
      'fa-table': 'ri-table-line',
      'fa-tasks': 'ri-task-line',
      'fa-columns': 'ri-layout-column-line',
      'fa-dollar': 'ri-money-dollar-circle-line',
      'fa-tools': 'ri-tools-line',
      'fa-sitemap': 'ri-node-tree',
      'fa-caret-square-o-right': 'ri-arrow-right-line',
      'fa-desktop': 'ri-computer-line',
      'fa-box': 'ri-box-3-line',
      'fa-plus': 'ri-add-box-line',
      'fa-list-alt': 'ri-list-check-2-line',
      // New icons for updated menu structure
      'ri-bar-chart-2-line': 'ri-bar-chart-2-line',
      'ri-home-4-line': 'ri-home-4-line',
      'ri-line-chart-line': 'ri-line-chart-line',
      'ri-bar-chart-grouped-line': 'ri-bar-chart-grouped-line',
      'ri-file-edit-line': 'ri-file-edit-line',
      'ri-file-list-2-line': 'ri-file-list-2-line',
      'ri-time-line': 'ri-time-line',
      'ri-checkbox-circle-line': 'ri-checkbox-circle-line',
      'ri-file-copy-2-line': 'ri-file-copy-2-line',
      'ri-file-list-3-line': 'ri-file-list-3-line',
      'ri-close-circle-line': 'ri-close-circle-line',
      'ri-file-damage-line': 'ri-file-damage-line',
      'ri-loop-right-line': 'ri-loop-right-line',
      'ri-contacts-book-2-line': 'ri-contacts-book-2-line',
      'ri-user-follow-line': 'ri-user-follow-line',
      'ri-user-unfollow-line': 'ri-user-unfollow-line',
      'ri-file-chart-line': 'ri-file-chart-line',
      'ri-folder-line': 'ri-folder-line',
      'ri-shield-line': 'ri-shield-line',
      'ri-list-check-2-line': 'ri-list-check-2-line',
      'ri-building-line': 'ri-building-line',
      'ri-building-2-line': 'ri-building-2-line',
      'ri-handshake-line': 'ri-handshake-line',
      'ri-percent-line': 'ri-percent-line',
      'ri-group-line': 'ri-group-line',
      'ri-map-pin-line': 'ri-map-pin-line',
      'ri-user-settings-line': 'ri-user-settings-line',
      'ri-history-line': 'ri-history-line',
      'ri-lock-line': 'ri-lock-line',
      'ri-money-dollar-circle-line': 'ri-money-dollar-circle-line',
      'ri-balance-line': 'ri-balance-line',
      'ri-refund-line': 'ri-refund-line',
      'ri-settings-3-line': 'ri-settings-3-line',
      'ri-settings-4-line': 'ri-settings-4-line',
      'ri-global-line': 'ri-global-line',
      'ri-secure-payment-line': 'ri-secure-payment-line',
      'ri-bank-card-line': 'ri-bank-card-line',
      'ri-mail-line': 'ri-mail-line',
      'ri-mail-settings-line': 'ri-mail-settings-line',
      'ri-message-3-line': 'ri-message-3-line',
      'ri-notification-3-line': 'ri-notification-3-line',
      'ri-file-download-line': 'ri-file-download-line',
      'ri-calendar-event-line': 'ri-calendar-event-line',
      'ri-lock-password-line': 'ri-lock-password-line',
      'ri-logout-box-line': 'ri-logout-box-line'
    };

    return iconMap[iconName] || iconName || 'ri-file-line';
  }

  isActiveRoute(route: string): boolean {
    const fullRoute = this.getRoute(route);
    return this.router.url === fullRoute;
  }

  newMessage(children: any, module: any) {
    const permissionData = JSON.stringify({
      is_delete_permission: module.is_delete_permisssion
    });
    const encrypted = this.auth.encrypt(permissionData);
    localStorage.setItem('perms', encrypted);
    this.menuAuth.changeMessage(children);
  }

  getIconClass(iconName: string): string {
    // Convert FontAwesome icons to Remix icons or keep existing
    const iconMap: { [key: string]: string } = {
      'fa-database': 'ri-database-line',
      'fa-user-cog': 'ri-user-settings-line',
      'fa fa-user': 'ri-user-line',
      'fas fa-balance-scale': 'ri-scales-line',
      'fa-shield': 'ri-shield-line',
      'fa-home': 'ri-home-line',
      'fa-product-hunt': 'ri-product-hunt-line',
      'fa-folder': 'ri-folder-line',
      'fa-list': 'ri-list-line',
      'fa-calculator': 'ri-calculator-line',
      'fa fa-users': 'ri-group-line',
      'fas fa-search-plus': 'ri-search-plus-line'
    };

    return iconMap[iconName] || iconName || 'ri-file-line';
  }


  hasChildren(module: ModuleItem): boolean {
    return !!(module.children.add || module.children.listing || module.children.lising);
  }

  logoutAdmin() {
    this._AuthService.logout().subscribe({
      next: (res: any) => {
        this.router.navigate(['/']);
        this.toastr.success(res.message, 'Success');
        const userItem = localStorage.getItem('user##');
        localStorage.clear();
        if (userItem) localStorage.setItem('user##', userItem);
        setTimeout(() => window.location.reload(), 100);
      },
      error: () => {
        this.toastr.error('Logout failed', 'Error');
      }
    });
  }

  GoToDashboard() {
    this.router.navigate(['admin/dashboard']);
  }

  changePassword() {
    this.router.navigate(['admin/change-password']);
  }

  initSidebarToggle() {
    setTimeout(() => {
      const subTreeviewItems = document.querySelectorAll('.treeview .treeview > a');
      subTreeviewItems.forEach(item => {
        item.addEventListener('click', function (e) {
          e.preventDefault();
          const parent = this.parentElement;
          const sibling = this.nextElementSibling;
          if (parent) {
            parent.classList.toggle('open');
          }
        });
      });
    }, 0);
  }
}




